module.exports = __webpack_public_path__ + "img/bl-2a-dub.17243e7e.jpg";